import React from 'react';
import { CountdownModal } from 'src/components/modals/countdown-modal';

export type KioskProIdleWarningProps = {
  startNewSession: () => void;
  closeAndContinue: () => void;
};

export const KioskProIdleWarning = ({ startNewSession, closeAndContinue }: KioskProIdleWarningProps): JSX.Element => (
  <CountdownModal
    startNewSession={startNewSession}
    closeAndContinue={closeAndContinue}
    timeLeftInSeconds={10}
    title='Are you still there?'
    subtitle='You will lose any items currently in your cart and have to start over.'
    primaryButtonText='Cancel & start over'
    secondaryButtonText='Keep Shopping'
  />
);
